



/* Built In Imports */
import { useState } from 'react';

/* External Imports */
import { Box, Flex, Image, List } from '@chakra-ui/react';
import Slider from 'react-slick';

/* Internal Imports */
/* Components */
//styles
import SectionTitle from '@components/Headings/SectionTitle';
import TopKolam from '@components/Headings/TopKolam';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser13';
import config from '@config';
import { render } from 'datocms-structured-text-to-html-string';
import { useMediaQuery } from 'react-responsive';
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";


/**
 * Renders the Testimonial component.
 *
 * @returns {ReactElement} Testimonial component.
 */

const OtherAspects = ({ sectionContent }) => {
    // console.log('Section contnt in other aspects', sectionContent)
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const isTab = useMediaQuery({ maxWidth: 1024 });
    // const [imgIndex, setImgIndex] = useState(0);
    // const [slidecount, setSlidecount] = useState('');
    // const [currentimage, setCurrentimage] = useState('');

    // const updatecount = (props, obj) => {
    //     let currentslide = props.currentSlide === 0 ? 3 : props?.currentSlide;
    //     if (obj === 'next' && props.currentSlide !== 0) {
    //         const remainingSlides = props.slideCount - props.currentSlide;
    //         currentslide = props.currentSlide + (remainingSlides > 3 ? 3 : remainingSlides);
    //     }
    //     setCurrentimage(currentslide);
    // };
    const [imgIndex, setImgIndex] = useState(0);
    const [slidecount, setSlidecount] = useState('');
    const [currentimage, setCurrentimage] = useState('');
    const updatecount = (props, obj) => {
        console.log("props is", props.currentSlide)
        let currentslide = props.currentSlide === 0 && isMobile ? 1 : props.currentSlide === 0 && isTab ? 2 : props?.currentSlide === 0 ? 3 : props?.currentSlide;
        console.log("slide ", props.currentslide)
        if (obj === 'next' && props.currentSlide !== 0) {
            const remainingSlides = props.slideCount - props.currentSlide;
            currentslide = isMobile ? props?.currentSlide + 1 : isTab ? props?.currentSlide + (remainingSlides > 2 ? 2 : remainingSlides) : props.currentSlide + (remainingSlides > 3 ? 3 : remainingSlides);
        }

        setCurrentimage(currentslide);
    };
    const NextArrow = props => {
        const { onClick } = props;
        updatecount(props, 'next');
        return (
            <Box
                pos="absolute"
                top={{ base: "-80px", sm: "-80px", md: "160px" }}
                right={{ base: "10px", sm: "10px", md: "-20px" }}
                zIndex="10"
                cursor="pointer"
                bgSize="10px"
                bgColor="#fff"
                border="0"
                borderRadius="100%"
                w={{
                    base: "40px", md: "62px", lg: "45px"
                }}
                h={{
                    base: "40px", md: "62px", lg: "45px"
                }}
                boxShadow="0 0 10px rgba(0, 0, 0, 0.5)"
                bgPos="center"
                bgRepeat="no-repeat"
                color="transparent"
                bgImage={`url(${config.staticPath}/d/46272/1734001288-right_arrow_2.svg)`}
                onClick={onClick}
            ></Box>
        );
    };
    const PrevArrow = props => {
        const { onClick } = props;
        updatecount(props, 'prev');
        return (
            <Box

                pos="absolute"
                top={{ base: "-80px", sm: "-80px", md: "160px" }}
                left={{ base: "70px", sm: "70px", md: "-50px", lg: "-90px" }}
                zIndex="10"
                cursor="pointer"
                bgSize="10px"
                bgColor="#fff"
                border="0"
                borderRadius="100%"
                w={{
                    base: "40px", md: "62px", lg: "45px"
                }}
                h={{
                    base: "40px", md: "62px", lg: "45px"
                }}
                boxShadow="0 0 10px rgba(0, 0, 0, 0.5)"
                bgPos="center"
                bgRepeat="no-repeat"
                color="transparent"
                bgImage={`url(${config.staticPath}/d/46272/1734001288-left_arrow_1.svg)`
                }
                // className={`${classes["meetSlick-arrow"]} ${classes.meetPrevArrow}`}
                onClick={onClick}
            />
        );
    };
    const settings = {
        infinite: true,
        lazyLoad: true,
        autoplay: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        className: "other-aspects",
        appendDots: dots => (
            <Box h="1px">
                <List margin='0px'> {dots} </List>
            </Box>
        ),
        customPaging: () => (
            <Box
                marginTop={"10px"}
                background={'#D2C8B5'}
                width="12px"
                rounded="full"
                height="12px"
            ></Box>
        ),
        beforeChange: (current, next) => {
            setCurrentimage(next + 1);
        },
        afterChange: (index) => setImgIndex(index),
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    arrows: true,
                    dots: false,
                },
            },
            {
                breakpoint: 1065,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: true,
                    dots: false,
                    // centerPadding: '0px 40px',

                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: false,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: false,
                    centerPadding: '30px 0px 0px',
                    centerMode: true,

                }
            }
        ],
    };

    return (
        <Box paddingTop={{ sm: "50px", base: "50px", md: "100px" }}
            paddingBottom={{ sm: "", base: "", lg: "25px" }}

        >
            <Box marginBottom={{ base: "50px", sm: "50px", md: "60px" }} marginTop={{ base: "40px", sm: "40px", md: "50px" }} display={"flex"} justifyContent={"center"} alignItems={"center"} position={"relative"}
            >
                <Box
                    width={{ sm: "282px", base: "282px", md: "auto" }}
                    color="white"
                    fontWeight={'500'}
                    fontSize={{base:"32px",md:"32px",sm:"30px",lg:"32px"}}
                    mx={{ base: '17px', md: 'auto' }}
                    lineHeight={{ base: "37px", sm: "37px", md: "37px" }}
                    fontFamily={'FedraSansStd-A-medium'}
                    textAlign={'center'}
                >
                    {sectionContent[0].titleText}
                </Box>
                <Box position={"absolute"} top={{ base: "55px", sm: "55px", md: "20px" }}>
                    <TopKolam
                        sectionContent={sectionContent[1]}
                    />
                </Box>
            </Box>
            <Box
                mt={{
                    base: "100px", sm: "100px", xl: "0px", md:"20px", lg:"20px"
                }}
            >
                <Flex
                    width={{ base: '340px', sm: "380px", md: '700px', lg: "881px", xl: '1100px' }}
                    mx="auto"
                    justifyContent="center"
                    flexDir="column"
                    h={{ base: "400px", md: "450px" }}
                    paddingLeft={{ base: '30px', sm: '30px', md: "40px", lg: '80px' }}
                >
                    <Slider {...settings}>
                        {sectionContent[2]?.cards?.map(section => {
                            // console.log("The card is", section)
                            return <Box
                                display="flex"
                                gap={"70px"}
                                // justifyContent={'center'}
                                // alignItems={"center"}
                                flexDirection="column"
                                maxWidth={{ base: 302, lg: "270px" }}
                                height={"380px"}
                            >
                                <Box
                                    mb={{ base: 4, md: 8 }}
                                    display={"flex"}
                                    justifyContent={"center"}
                                    alignItems={"center"}
                                // minH={{ base: '188px', sm: '148px', md: '270px' }}
                                >
                                    {' '}
                                    <Image
                                        src={section.thumbnail?.url}
                                        title={section.thumbnail?.title}
                                        alt={section.thumbnail?.alt}
                                        maxWidth={{ base: 190, md: 270 }}
                                    />
                                </Box>

                                <Box
                                    as="h2"
                                    fontSize={{ base: '18px', md: '18px' }}
                                    color="white"
                                    fontWeight={"bold"}
                                    fontFamily={"FedraSansStd-book"}
                                    whiteSpace={"nowrap"}
                                    mb={"12px"}
                                    textAlign={"center"}
                                >
                                    {section.title}
                                </Box>
                                <Box
                                    as="p"
                                    fontFamily="FedraSansStd-book"
                                    fontSize="16px"
                                    fontWeight={"350"}
                                    color="#FDE6B7"
                                    textAlign={'center'}
                                    //lineHeight={'24'}
                                    px={{ base: '10px', sm: '10px', md: '0px' }}
                                >
                                    <StructuredTextParser
                                        str={render(section.description)}
                                        textAlign="center"
                                        mt="0"
                                    />
                                </Box>
                            </Box>
                        })}
                    </Slider>
                    <style>
                        {
                            `
            .other-aspects .slick-dots .slick-active div{
              background:#711B0F;
            }
            `
                        }
                    </style>
                </Flex>
                <Box
                    textAlign="center"
                    fontFamily="FedraSansStd-book, sans-serif"
                    fontSize="16px"
                    fontWeight="600"
                    pb="35px"
                    //mt={{ base: "-30px", sm: "0px", md: "-30px" }}
                    color={"white"}
                    letterSpacing={'-1px'}

                >
                    {currentimage} / {sectionContent[2]?.cards?.length}
                </Box>
            </Box>
        </Box >
    );
};

export default OtherAspects;

